// ════════════════════════════════════════════════════════════
// Tarifario — precios de servicio, editables en línea
// ════════════════════════════════════════════════════════════
import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Alert, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, TextField, IconButton, CircularProgress, Chip
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { getTarifario, actualizarTarifa } from '../api';

export default function Tarifario({ puedeEditar }: { puedeEditar: boolean }) {
  const [items, setItems] = useState<any[]>([]);
  const [editados, setEditados] = useState<Record<string, string>>({});
  const [cargando, setCargando] = useState(true);
  const [msg, setMsg] = useState('');

  const cargar = () => {
    getTarifario().then((d: any) => { setItems(d); setEditados({}); })
      .finally(() => setCargando(false));
  };
  useEffect(() => { cargar(); }, []);

  const guardar = async (clave: string) => {
    const valor = parseFloat(editados[clave]);
    if (isNaN(valor) || valor < 0) { alert('Precio no válido'); return; }
    try {
      await actualizarTarifa(clave, { precio: valor });
      setMsg('Tarifa actualizada. Las intervenciones ya registradas conservan su precio anterior.');
      setTimeout(() => setMsg(''), 4000);
      cargar();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al guardar');
    }
  };

  if (cargando) return <CircularProgress />;

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Precios aplicados a las intervenciones. Al registrar un tiempo, el sistema calcula
        el importe con la tarifa vigente y la deja congelada en esa línea: los cambios
        futuros no alteran lo ya registrado.
      </Typography>

      {msg && <Alert severity="success" sx={{ mb: 2 }}>{msg}</Alert>}
      {!puedeEditar && (
        <Alert severity="info" sx={{ mb: 2 }}>Solo consulta. No tienes permiso para modificar el tarifario.</Alert>
      )}

      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Concepto</TableCell>
              <TableCell sx={{ fontWeight: 700, display: { xs: 'none', md: 'table-cell' } }}>Horario</TableCell>
              <TableCell sx={{ fontWeight: 700, width: 170 }} align="right">Precio</TableCell>
              {puedeEditar && <TableCell sx={{ width: 50 }} />}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((t: any) => {
              const editando = editados[t.clave] !== undefined;
              return (
                <TableRow key={t.clave}>
                  <TableCell>{t.concepto}</TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                    <Typography variant="caption" color="text.secondary">{t.detalle || '—'}</Typography>
                  </TableCell>
                  <TableCell align="right">
                    {puedeEditar ? (
                      <TextField size="small" type="number" variant="standard"
                        value={editando ? editados[t.clave] : t.precio}
                        onChange={(e) => setEditados({ ...editados, [t.clave]: e.target.value })}
                        inputProps={{ style: { textAlign: 'right', fontWeight: 700 } }}
                        sx={{ width: 110 }} />
                    ) : (
                      <Typography sx={{ fontWeight: 700 }}>{t.precio}</Typography>
                    )}
                    <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
                      €/{t.unidad}
                    </Typography>
                  </TableCell>
                  {puedeEditar && (
                    <TableCell>
                      {editando && (
                        <IconButton size="small" color="primary" onClick={() => guardar(t.clave)}>
                          <SaveIcon fontSize="small" />
                        </IconButton>
                      )}
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}